import script from "./FilesManager.vue?vue&type=script&setup=true&lang=js"
export * from "./FilesManager.vue?vue&type=script&setup=true&lang=js"

import "./FilesManager.vue?vue&type=style&index=0&id=998f1f2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-998f1f2c"]])

export default __exports__